import { ModuleType } from "../module";
var buildColumns = function(key, column1Content, column2Content) {
    return {
        columns: [
            column1Content,
            column2Content
        ],
        id: key,
        key: key,
        type: ModuleType.Columns
    };
};
export { buildColumns };
